import Icon from '../components/Icon';

const CheckCircleFilled = Icon(
  'check-circle-filled',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25m4.637 7.613a.9.9 0 0 0-1.274 0L10.7 13.526l-2.063-2.064a.9.9 0 0 0-1.274 1.272l2.702 2.701a.9.9 0 0 0 1.272 0l5.3-5.298a.9.9 0 0 0 0-1.274"
      clipRule="evenodd"
    />
  </>
);

export default CheckCircleFilled;
